import { type FieldPath, type FieldPathValues, type FieldValues, useFormContext, useWatch } from 'react-hook-form'

export const createUseFormValues =
	<TForm extends FieldValues>() =>
	<TFieldNames extends readonly FieldPath<TForm>[]>(fields: readonly [...TFieldNames]): FieldPathValues<TForm, TFieldNames> => {
		const form = useFormContext<TForm>()
		return useWatch({ control: form.control, name: fields }) as FieldPathValues<TForm, TFieldNames>
	}
